import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const DepartmentSummaryCard = ({ title, value, helper, accent, icon: Icon }) => {
  return (
    <Card
      sx={{
        height: '100%',
        borderRadius: 3,
        border: '1px solid #e5e7eb',
        boxShadow: '0 12px 30px rgba(15, 23, 42, 0.06)'
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2 }}>
          <Box>
            <Typography variant="body2" sx={{ color: '#6b7280', fontWeight: 600 }}>
              {title}
            </Typography>
            <Typography variant="h4" sx={{ mt: 1, fontWeight: 700, color: '#111827' }}>
              {value}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1, color: '#6b7280' }}>
              {helper}
            </Typography>
          </Box>
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: '14px',
              bgcolor: `${accent}1A`,
              color: accent,
              display: 'grid',
              placeItems: 'center'
            }}
          >
            <Icon fontSize="small" />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DepartmentSummaryCard;
